export const BASE_SELECTOR: string = '[data-region-notification]';
export const REDIRECT_BUTTON: string = '.button';

export class RegionNotificationUI {
    public constructor(private $base: JQuery) {
    }

    public showNotification() {
        this.$base.show();
    }
}

export function createRegionNotificationInstances(): RegionNotificationUI[] {
    const instances: RegionNotificationUI[] = [];
    $(BASE_SELECTOR).each((index, element) => {
        instances.push(new RegionNotificationUI($(element)));
    });
    return instances;
}
